import { Sounds } from "./Options/Classes/Sounds";
import { SoundsInstance } from "./SoundsInstance";
class SoundsPlugin {
    constructor(engine) {
        this.id = "sounds";
        this._engine = engine;
    }
    getPlugin(container) {
        return new SoundsInstance(container, this._engine);
    }
    loadOptions(options, source) {
        if (!this.needsPlugin(options) && !this.needsPlugin(source)) {
            return;
        }
        let soundsOptions = options.sounds;
        if (soundsOptions?.load === undefined) {
            options.sounds = soundsOptions = new Sounds();
        }
        soundsOptions.load(source?.sounds);
    }
    needsPlugin(options) {
        return options?.sounds?.enable ?? false;
    }
}
export async function loadSoundsPlugin(engine) {
    const plugin = new SoundsPlugin(engine);
    await engine.addPlugin(plugin);
}
